import type { PrivacyBlock } from '../content/privacyPolicy'
import { privacyMeta, privacySections } from '../content/privacyPolicy'

function Blocks({ blocks }: { blocks: PrivacyBlock[] }) {
  const rendered: React.ReactNode[] = []
  let list: string[] = []

  const flushList = () => {
    if (list.length) {
      rendered.push(
        <ul key={`ul-${rendered.length}`} className="mb-3 list-disc space-y-1 pl-6 text-neutral-800">
          {list.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>,
      )
      list = []
    }
  }

  for (const block of blocks) {
    if (block.kind === 'li') {
      list.push(block.text)
      continue
    }
    flushList()
    if (block.kind === 'label') {
      rendered.push(
        <p key={`label-${rendered.length}`} className="mt-3 mb-1 font-semibold text-neutral-900">
          {block.text}
        </p>,
      )
    } else {
      rendered.push(
        <p key={`p-${rendered.length}`} className="mb-3 text-justify leading-relaxed text-neutral-800">
          {block.text}
        </p>,
      )
    }
  }
  flushList()
  return <>{rendered}</>
}

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-neutral-50 py-10 print:bg-white">
      <div className="mx-auto max-w-5xl px-4">
        <div className="rounded-lg border border-neutral-200 bg-white p-6 shadow-sm print:border-0 print:shadow-none sm:p-10">
          <h1 className="text-center font-serif text-2xl font-bold tracking-wide text-neutral-900">
            {privacyMeta.site}
            <br />
            Privacy Policy
          </h1>
          <p className="mt-2 text-center text-sm text-neutral-500">{privacyMeta.governed}</p>
          <p className="mb-8 text-center text-xs uppercase tracking-widest text-neutral-500">
            Last updated: {privacyMeta.lastUpdated}
          </p>

          <nav className="mb-10 rounded-lg bg-neutral-50 p-4 print:hidden" aria-label="Contents">
            <h2 className="mb-2 text-sm font-semibold text-neutral-900">Contents</h2>
            <ol className="list-decimal space-y-1 pl-5 text-sm text-primary-700">
              {privacySections.map((s) => (
                <li key={s.number}>
                  <a href={`#section-${s.number}`} className="hover:underline">
                    {s.title}
                  </a>
                </li>
              ))}
            </ol>
          </nav>

          {privacySections.map((s) => (
            <section key={s.number} id={`section-${s.number}`} className="mb-8 scroll-mt-6">
              <h2 className="mb-3 font-serif text-lg font-semibold text-neutral-900">
                {s.number}. {s.title}
              </h2>
              <Blocks blocks={s.blocks} />
            </section>
          ))}
        </div>
      </div>
    </div>
  )
}
